/**
 * Content that is generated via React Helmet
 */

import * as React from 'react';
import Helmet from 'react-helmet';

export interface HelmetterProps {
}

export default class Helmetter extends React.Component<HelmetterProps, any> {
  public render() {
    return (
      <Helmet>
        <title>50.cs.pub.ro | Computer Department Semicentenary Anniversary</title>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#2b5797" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
    );
  }
}
